import { call, put, takeLatest } from 'redux-saga/effects';
import { checkPostalCode } from '../utils/orders';
import { GET_DETAIL_SHIPMENT, GET_DETAIL_SHIPMENT_FAILS, GET_DETAIL_SHIPMENT_SUCCESS } from './../actions/detailShipment';
import { GET_SHIPMENT_BY_ID, GET_SHIPMENT_BY_ID_FAILS, GET_SHIPMENT_BY_ID_SUCCESS } from './../actions/shipmentAction';
import hanldeException from './../services/handleException';
import { getShipmentById } from './../utils/shipment';
import history from './../services/history'
import { StatusFilterShipment } from './../constants'
import { dialogError } from './../services/dialog'
import lang from './../languages/en'

export function* getShipmentByIdSaga() {
    yield takeLatest(GET_SHIPMENT_BY_ID, getShipmentByIdHandle)
}

function* getShipmentByIdHandle(action) {
    try {
        const response = yield call(getShipmentById, action.payload)
        if (response.data.code !== 10001) {
            yield put({ type: GET_SHIPMENT_BY_ID_FAILS, payload: response })
            hanldeException(response)
        }

        const postalCode = yield call(checkPostalCode, response.data.data.Shipment.ConsigneePostalCodeCH)
        if (response.data.code === 10001) {
            if(response.data.data.Shipment.Packages[0]['StatusID'] === StatusFilterShipment.SHIPPED) {
                history.push('/shipments')
                dialogError(lang.transmit_fails)
            }
            response['postalCode'] = postalCode.data.data
            yield put({ type: GET_SHIPMENT_BY_ID_SUCCESS, payload: response })
        }
    } catch (error) {
        yield put({ type: GET_SHIPMENT_BY_ID_FAILS, payload: error })
        hanldeException(error)
    }
}

export function* getDetailShipmentSaga() {
    yield takeLatest(GET_DETAIL_SHIPMENT, getDetailShipmentHandle)
}

function* getDetailShipmentHandle(action) {
    try {
        const response = yield call(getShipmentById, action.payload)

        if (response.data.code === 10001) {
            yield put({ type: GET_DETAIL_SHIPMENT_SUCCESS, payload: response })
        } else {
            yield put({ type: GET_DETAIL_SHIPMENT_FAILS, payload: response })
            hanldeException(response)
        }
    } catch (error) {
        yield put({ type: GET_DETAIL_SHIPMENT_FAILS, payload: error })
        hanldeException(error)
    }
}




// WEBPACK FOOTER //
// ./src/sagas/getShipmentByIdSaga.js